import * as ambassadorWixQuickpagesMaterializedpagesV1MaterializedPage from './quickpages-materializedpages-v1-materialized-page-materialized-pages.http.js';
import * as ambassadorWixQuickpagesMaterializedpagesV1MaterializedPageTypes from './quickpages-materializedpages-v1-materialized-page-materialized-pages.types.js';
import * as ambassadorWixQuickpagesMaterializedpagesV1MaterializedPageUniversalTypes from './quickpages-materializedpages-v1-materialized-page-materialized-pages.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getMaterializedPage(): __PublicMethodMetaInfo<
  'GET',
  { materializedPageId: string },
  ambassadorWixQuickpagesMaterializedpagesV1MaterializedPageUniversalTypes.GetMaterializedPageRequest,
  ambassadorWixQuickpagesMaterializedpagesV1MaterializedPageTypes.GetMaterializedPageRequest,
  ambassadorWixQuickpagesMaterializedpagesV1MaterializedPageUniversalTypes.GetMaterializedPageResponse,
  ambassadorWixQuickpagesMaterializedpagesV1MaterializedPageTypes.GetMaterializedPageResponse
> {
  const payload = { materializedPageId: ':materializedPageId' } as any;

  const getRequestOptions =
    ambassadorWixQuickpagesMaterializedpagesV1MaterializedPage.getMaterializedPage(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/materialized-pages/{materializedPageId}',
    pathParams: { materializedPageId: 'materializedPageId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchMaterializedPages(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixQuickpagesMaterializedpagesV1MaterializedPageUniversalTypes.SearchMaterializedPagesRequest,
  ambassadorWixQuickpagesMaterializedpagesV1MaterializedPageTypes.SearchMaterializedPagesRequest,
  ambassadorWixQuickpagesMaterializedpagesV1MaterializedPageUniversalTypes.SearchMaterializedPagesResponse,
  ambassadorWixQuickpagesMaterializedpagesV1MaterializedPageTypes.SearchMaterializedPagesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixQuickpagesMaterializedpagesV1MaterializedPage.searchMaterializedPages(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/materialized-pages/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  MaterializedPage as MaterializedPageOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  Image as ImageOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  PublicationDetails as PublicationDetailsOriginal,
  ContentDetails as ContentDetailsOriginal,
  PageRoute as PageRouteOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  GetMaterializedPageRequest as GetMaterializedPageRequestOriginal,
  GetMaterializedPageResponse as GetMaterializedPageResponseOriginal,
  SearchMaterializedPagesRequest as SearchMaterializedPagesRequestOriginal,
  CursorSearch as CursorSearchOriginal,
  CursorSearchPagingMethodOneOf as CursorSearchPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Aggregation as AggregationOriginal,
  AggregationKindOneOf as AggregationKindOneOfOriginal,
  RangeBucket as RangeBucketOriginal,
  SortType as SortTypeOriginal,
  SortTypeWithLiterals as SortTypeWithLiteralsOriginal,
  SortDirection as SortDirectionOriginal,
  SortDirectionWithLiterals as SortDirectionWithLiteralsOriginal,
  MissingValues as MissingValuesOriginal,
  MissingValuesWithLiterals as MissingValuesWithLiteralsOriginal,
  IncludeMissingValuesOptions as IncludeMissingValuesOptionsOriginal,
  ScalarType as ScalarTypeOriginal,
  ScalarTypeWithLiterals as ScalarTypeWithLiteralsOriginal,
  ValueAggregation as ValueAggregationOriginal,
  ValueAggregationOptionsOneOf as ValueAggregationOptionsOneOfOriginal,
  NestedAggregationType as NestedAggregationTypeOriginal,
  NestedAggregationTypeWithLiterals as NestedAggregationTypeWithLiteralsOriginal,
  RangeAggregation as RangeAggregationOriginal,
  ScalarAggregation as ScalarAggregationOriginal,
  DateHistogramAggregation as DateHistogramAggregationOriginal,
  Interval as IntervalOriginal,
  IntervalWithLiterals as IntervalWithLiteralsOriginal,
  NestedAggregationItem as NestedAggregationItemOriginal,
  NestedAggregationItemKindOneOf as NestedAggregationItemKindOneOfOriginal,
  AggregationType as AggregationTypeOriginal,
  AggregationTypeWithLiterals as AggregationTypeWithLiteralsOriginal,
  NestedAggregation as NestedAggregationOriginal,
  SearchDetails as SearchDetailsOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  SearchMaterializedPagesResponse as SearchMaterializedPagesResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  AggregationData as AggregationDataOriginal,
  ValueAggregationResult as ValueAggregationResultOriginal,
  RangeAggregationResult as RangeAggregationResultOriginal,
  NestedAggregationResults as NestedAggregationResultsOriginal,
  NestedAggregationResultsResultOneOf as NestedAggregationResultsResultOneOfOriginal,
  ValueResults as ValueResultsOriginal,
  RangeResults as RangeResultsOriginal,
  AggregationResultsScalarResult as AggregationResultsScalarResultOriginal,
  NestedValueAggregationResult as NestedValueAggregationResultOriginal,
  ValueResult as ValueResultOriginal,
  RangeResult as RangeResultOriginal,
  ScalarResult as ScalarResultOriginal,
  NestedResultValue as NestedResultValueOriginal,
  NestedResultValueResultOneOf as NestedResultValueResultOneOfOriginal,
  Results as ResultsOriginal,
  DateHistogramResult as DateHistogramResultOriginal,
  GroupByValueResults as GroupByValueResultsOriginal,
  DateHistogramResults as DateHistogramResultsOriginal,
  NestedResults as NestedResultsOriginal,
  AggregationResults as AggregationResultsOriginal,
  AggregationResultsResultOneOf as AggregationResultsResultOneOfOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './quickpages-materializedpages-v1-materialized-page-materialized-pages.types.js';
